var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-card",
        { attrs: { bordered: false } },
        [
          _c(
            "div",
            { staticClass: "table-page-search-wrapper" },
            [
              _c(
                "a-form",
                {
                  attrs: { layout: "inline" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.searchQuery.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "单据号",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c("a-input", {
                                attrs: { placeholder: "请输入单据号" },
                                model: {
                                  value: _vm.queryParam.billNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParam, "billNo", $$v)
                                  },
                                  expression: "queryParam.billNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "维修类型",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  attrs: {
                                    placeholder: "请选择维修类型",
                                    "allow-clear": "",
                                  },
                                  model: {
                                    value: _vm.queryParam.repairType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParam,
                                        "repairType",
                                        $$v
                                      )
                                    },
                                    expression: "queryParam.repairType",
                                  },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "费用化" } },
                                    [_vm._v("费用化")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "资本化" } },
                                    [_vm._v("资本化")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "状态",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  attrs: {
                                    placeholder: "请选择状态",
                                    "allow-clear": "",
                                  },
                                  model: {
                                    value: _vm.queryParam.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryParam, "status", $$v)
                                    },
                                    expression: "queryParam.status",
                                  },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "0" } },
                                    [_vm._v("未审核")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "1" } },
                                    [_vm._v("已审核")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "单据日期",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c("a-range-picker", {
                                staticStyle: { width: "100%" },
                                attrs: { format: "YYYY-MM-DD" },
                                on: { change: _vm.onDateChange },
                                model: {
                                  value: _vm.queryParam.dateRange,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParam, "dateRange", $$v)
                                  },
                                  expression: "queryParam.dateRange",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "table-page-search-submitButtons",
                          staticStyle: { float: "left", overflow: "hidden" },
                        },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.searchQuery },
                                },
                                [_vm._v("查询")]
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  on: { click: _vm.searchReset },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "table-operator",
              staticStyle: { "margin-top": "5px" },
            },
            [
              _vm.btnEnableList.indexOf("1") > -1
                ? _c(
                    "a-button",
                    {
                      attrs: { type: "primary", icon: "plus" },
                      on: { click: _vm.openAdd },
                    },
                    [_vm._v("新增")]
                  )
                : _vm._e(),
              _c(
                "a-button",
                {
                  staticStyle: { "margin-left": "8px" },
                  attrs: { icon: "sync" },
                  on: { click: _vm.loadData },
                },
                [_vm._v("刷新")]
              ),
              _vm.btnEnableList.indexOf("3") > -1
                ? _c(
                    "a-button",
                    {
                      staticStyle: { "margin-left": "8px" },
                      attrs: { icon: "download" },
                      on: { click: _vm.exportExcel },
                    },
                    [_vm._v("导出")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("a-table", {
            attrs: {
              bordered: "",
              size: "middle",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.tableData,
              loading: _vm.loading,
              pagination: false,
              scroll: _vm.tableScroll,
            },
            scopedSlots: _vm._u([
              {
                key: "billTime",
                fn: function (text) {
                  return _c("span", {}, [
                    _vm._v(_vm._s(text ? text.substring(0, 10) : "")),
                  ])
                },
              },
              {
                key: "status",
                fn: function (text) {
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "a-tag",
                        { attrs: { color: text === "1" ? "green" : "orange" } },
                        [_vm._v(_vm._s(text === "1" ? "已审核" : "未审核"))]
                      ),
                    ],
                    1
                  )
                },
              },
              {
                key: "action",
                fn: function (text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handlePrint(record)
                            },
                          },
                        },
                        [_vm._v("打印")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      record.status === "0"
                        ? [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openEdit(record)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            _c("a-divider", { attrs: { type: "vertical" } }),
                            _vm.canAudit(_vm.billPrefix(record.billNo))
                              ? _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleAudit(record)
                                      },
                                    },
                                  },
                                  [_vm._v("审核")]
                                )
                              : _vm._e(),
                            _vm.canAudit(_vm.billPrefix(record.billNo))
                              ? _c("a-divider", { attrs: { type: "vertical" } })
                              : _vm._e(),
                            _vm.canSubmitFlow(_vm.billPrefix(record.billNo))
                              ? _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleSubmitFlow(record)
                                      },
                                    },
                                  },
                                  [_vm._v("提交审批")]
                                )
                              : _vm._e(),
                            _vm.canSubmitFlow(_vm.billPrefix(record.billNo))
                              ? _c("a-divider", { attrs: { type: "vertical" } })
                              : _vm._e(),
                            _c(
                              "a-popconfirm",
                              {
                                attrs: { title: "作废并删除该单据?" },
                                on: { confirm: () => _vm.handleDelete(record) },
                              },
                              [
                                _c("a", { staticStyle: { color: "red" } }, [
                                  _vm._v("作废"),
                                ]),
                              ]
                            ),
                          ]
                        : [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openDetail(record)
                                  },
                                },
                              },
                              [_vm._v("详情")]
                            ),
                            _c("a-divider", { attrs: { type: "vertical" } }),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleUnaudit(record)
                                  },
                                },
                              },
                              [_vm._v("反审核")]
                            ),
                          ],
                    ],
                    2
                  )
                },
              },
            ]),
          }),
          _c("a-pagination", {
            staticStyle: { "margin-top": "12px", "text-align": "right" },
            attrs: {
              "show-size-changer": "",
              "show-quick-jumper": "",
              current: _vm.ipagination.current,
              "page-size": _vm.ipagination.pageSize,
              "page-size-options": _vm.ipagination.pageSizeOptions,
              total: _vm.ipagination.total,
            },
            on: {
              change: _vm.handleTableChange,
              showSizeChange: _vm.handleTableChange,
            },
          }),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.form.id ? "编辑维修单" : "新增维修单",
            width: 560,
            visible: _vm.visible,
            maskClosable: false,
          },
          on: {
            cancel: function ($event) {
              _vm.visible = false
            },
          },
        },
        [
          _c(
            "a-form",
            { attrs: { layout: "vertical" } },
            [
              _c(
                "a-form-item",
                { attrs: { label: "资产（必选）" } },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "选择资产",
                        "show-search": "",
                        "option-filter-prop": "children",
                        disabled: !!_vm.form.id,
                      },
                      model: {
                        value: _vm.form.assetId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "assetId", $$v)
                        },
                        expression: "form.assetId",
                      },
                    },
                    _vm._l(_vm.assetOptions, function (a) {
                      return _c(
                        "a-select-option",
                        { key: a.id, attrs: { value: a.id } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(a.assetCode) +
                              " " +
                              _vm._s(a.assetName) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-item",
                { attrs: { label: "维修类型（必选）" } },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "选择维修类型" },
                      model: {
                        value: _vm.form.repairType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "repairType", $$v)
                        },
                        expression: "form.repairType",
                      },
                    },
                    [
                      _c("a-select-option", { attrs: { value: "费用化" } }, [
                        _vm._v("费用化（计入当期费用）"),
                      ]),
                      _c("a-select-option", { attrs: { value: "资本化" } }, [
                        _vm._v("资本化（增加资产原值）"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-item",
                { attrs: { label: "维修金额（必填）" } },
                [
                  _c("a-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { min: 0, precision: 2 },
                    model: {
                      value: _vm.form.amount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "amount", $$v)
                      },
                      expression: "form.amount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                { attrs: { label: "维修内容" } },
                [
                  _c("a-textarea", {
                    attrs: { rows: 3 },
                    model: {
                      value: _vm.form.repairContent,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "repairContent", $$v)
                      },
                      expression: "form.repairContent",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                { attrs: { label: "贷方科目编码（缺省按凭证规则映射）" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "如 1002（留空走映射）" },
                    model: {
                      value: _vm.form.creditCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "creditCode", $$v)
                      },
                      expression: "form.creditCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                { attrs: { label: "单据日期（必填）" } },
                [
                  _c("a-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: { format: "YYYY-MM-DD" },
                    model: {
                      value: _vm.form.billTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "billTime", $$v)
                      },
                      expression: "form.billTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("a-input", {
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              !_vm.multiOn(_vm.modalPrefix())
                ? _c(
                    "a-button",
                    {
                      attrs: { loading: _vm.saving },
                      on: { click: _vm.handleSave },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              !_vm.multiOn(_vm.modalPrefix()) || !_vm.flowOn(_vm.modalPrefix())
                ? _c(
                    "a-button",
                    {
                      attrs: { loading: _vm.saving },
                      on: { click: _vm.handleSaveAndCheck },
                    },
                    [_vm._v("保存并审核")]
                  )
                : _vm._e(),
              _vm.multiOn(_vm.modalPrefix()) && _vm.flowOn(_vm.modalPrefix())
                ? _c(
                    "a-button",
                    {
                      attrs: { loading: _vm.saving },
                      on: { click: _vm.handleSaveAndFlow },
                    },
                    [_vm._v("保存并提交流程")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "维修单详情",
            width: 560,
            visible: _vm.detailVisible,
            footer: null,
          },
          on: {
            cancel: function ($event) {
              _vm.detailVisible = false
            },
          },
        },
        [
          _c(
            "a-descriptions",
            { attrs: { bordered: "", size: "small", column: 1 } },
            [
              _c("a-descriptions-item", { attrs: { label: "单据号" } }, [
                _vm._v(_vm._s(_vm.detail.billNo)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "资产" } }, [
                _vm._v(
                  _vm._s(_vm.detail.assetCode) +
                    " " +
                    _vm._s(_vm.detail.assetName)
                ),
              ]),
              _c("a-descriptions-item", { attrs: { label: "维修类型" } }, [
                _vm._v(_vm._s(_vm.detail.repairType)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "维修金额" } }, [
                _vm._v(_vm._s(_vm.detail.amount)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "维修内容" } }, [
                _vm._v(_vm._s(_vm.detail.repairContent)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "单据日期" } }, [
                _vm._v(_vm._s(_vm.detail.billTime)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "备注" } }, [
                _vm._v(_vm._s(_vm.detail.remark)),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("asset-bill-print", { ref: "assetPrint" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }